'use client';

import { ReactNode } from 'react';
import { useActiveInUrl } from './hooks/active-in-url';

export default function CollapsibleContainerClient({
  id,
  header,
  content,
  className,
  initialOpen = false,
}: {
  id: number | string,
  header: ReactNode,
  content: ReactNode,
  className?: string,
  initialOpen?: boolean,
}) {
  const [open, setOpen,] = useActiveInUrl(id, initialOpen);

  return (
    <div className={`collapsible-container ${open ? `collapsible-open` : ``} ${className ?? ``}`}>
      <div
        className="collapsible-header"
        onClick={() => setOpen(!open)}
      >
        <div className="collapsible-header-content">{header}</div>
        <svg
          className="collapsible-chevron"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="1em"
          height="1em"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
      {open && (
        <div className="collapsible-content">
          {content}
        </div>
      )}
    </div>
  );
}
